var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6804 16.4308V11.2063H13.4302L13.6919 9.17535H11.6804V7.87935C11.6804 7.29135 11.8439 6.8901 12.6869 6.8901H13.7624V5.0736C13.2418 5.01836 12.7185 4.99157 12.1949 4.99335C10.6447 4.99335 9.58341 5.93985 9.58341 7.67835V9.17535H7.82991V11.2063H9.58341V16.4308H3.12891C2.92999 16.4308 2.73923 16.3518 2.59858 16.2112C2.45792 16.0705 2.37891 15.8798 2.37891 15.6808V3.68085C2.37891 3.48193 2.45792 3.29117 2.59858 3.15052C2.73923 3.00986 2.92999 2.93085 3.12891 2.93085H15.1289C15.3278 2.93085 15.5186 3.00986 15.6592 3.15052C15.7999 3.29117 15.8789 3.48193 15.8789 3.68085V15.6808C15.8789 15.8798 15.7999 16.0705 15.6592 16.2112C15.5186 16.3518 15.3278 16.4308 15.1289 16.4308H11.6804Z",
    fill: "#9FDCE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.128906 0.680847)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.649fe93dfd3a6104768e9eb65a4d9b8d.svg";
export { ForwardRef as ReactComponent };